// api/notifications.ts
import { fetchAPI } from "./utils";
import {
    GetNotificationsParams,
    CreateNotificationParams,
    UpdateNotificationParams,
    DeleteNotificationParams,
} from "../types/requestInputs";
import {
    GetNotificationsResponse,
    CreateNotificationResponse,
    UpdateNotificationResponse,
    DeleteNotificationResponse,
} from "../types/requestsOutputs";

// Fetch all notifications
export const getNotifications = async ({ token }: GetNotificationsParams): Promise<GetNotificationsResponse> => {
    return fetchAPI<GetNotificationsResponse>("/get-notifications", "GET", undefined, token);
};

// Create a new notification
export const createNotification = async ({
    token,
    payload,
}: CreateNotificationParams): Promise<CreateNotificationResponse> => {
    return fetchAPI<CreateNotificationResponse>("/create-notification", "POST", payload, token);
};

// Update an existing notification
export const updateNotification = async ({
    token,
    id,
    payload,
}: UpdateNotificationParams): Promise<UpdateNotificationResponse> => {
    return fetchAPI<UpdateNotificationResponse>(
        `/update-notification`,
        "POST",
        { notificationId: id, ...payload },
        token,
    );
};

// Delete a notification
export const deleteNotification = async ({
    token,
    id,
}: DeleteNotificationParams): Promise<DeleteNotificationResponse> => {
    return fetchAPI<DeleteNotificationResponse>(`/delete-notification`, "POST", { notificationId: id }, token);
};
